var _rect, _rect2, _text, _text2, _rect3, _rect4, _text3, _text4, _path, _circle, _circle2, _path2, _circle3, _circle4, _rect5, _circle5, _rect6, _circle6, _text5, _text6, _rect7, _circle7, _text7, _text8, _rect8, _circle8, _text9, _text0, _rect9, _circle9, _text1, _text10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreVehicleConditionIntelligenceReviewInterface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 660,
    height: 510,
    viewBox: "0 0 660 510",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore vehicle condition review interface") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 660,
    height: 510,
    rx: 30,
    fill: "#FFFFFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 658,
    height: 508,
    rx: 29,
    fill: "none",
    stroke: "#D2E1F2",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 46,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850,
    textAnchor: "start",
    letterSpacing: 2
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 32,
    dy: 0
  }, "CONDITION REVIEW"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 82,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 22,
    fontWeight: 830,
    textAnchor: "start",
    letterSpacing: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 32,
    dy: 0
  }, "Shift comparison \xB7 FC\u20132047"))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 108,
    width: 286,
    height: 174,
    rx: 18,
    fill: "#EAF3FD",
    stroke: "#D2E1F2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 342,
    y: 108,
    width: 286,
    height: 174,
    rx: 18,
    fill: "#FFF0F6",
    stroke: "#FFC3DA"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 140,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850
  }, "PRIOR HANDOVER")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 362,
    y: 140,
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850
  }, "LATEST HANDOVER")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78 214h188l-28-43H112z",
    fill: "#C4D5E6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 221,
    r: 18,
    fill: "#07152A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 224,
    cy: 221,
    r: 18,
    fill: "#07152A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M388 214h188l-28-43H422z",
    fill: "#C4D5E6"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 221,
    r: 18,
    fill: "#07152A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 534,
    cy: 221,
    r: 18,
    fill: "#07152A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 389,
    y: 179,
    width: 56,
    height: 42,
    rx: 7,
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 417,
    cy: 200,
    r: 5,
    fill: "#FF2775"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 310,
    width: 596,
    height: 72,
    rx: 16,
    fill: "#07152A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 346,
    r: 10,
    fill: "#FF2775"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 89,
    y: 340,
    fill: "#fff",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 820
  }, "Potential bumper scuff surfaced")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 89,
    y: 361,
    fill: "#AFC0D6",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 650
  }, "Compare imagery before assigning responsibility.")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 405,
    width: 190,
    height: 70,
    rx: 14,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 430,
    r: 5,
    fill: "#FF2775"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 434,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 800
  }, "EXTERIOR")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 458,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 780
  }, "Observation")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 405,
    width: 190,
    height: 70,
    rx: 14,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 258,
    cy: 430,
    r: 5,
    fill: "#30D6A1"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 272,
    y: 434,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 800
  }, "TYRES")), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 258,
    y: 458,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 780
  }, "No visible change")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 436,
    y: 405,
    width: 190,
    height: 70,
    rx: 14,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 460,
    cy: 430,
    r: 5,
    fill: "#F5B642"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 474,
    y: 434,
    fill: "#536985",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 800
  }, "CLEANLINESS")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 458,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 780
  }, "Review")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreVehicleConditionIntelligenceReviewInterface);
export default __webpack_public_path__ + "static/media/fleetcore-vehicle-condition-intelligence-review-interface.2fca17157ff3e6c4cbb82ea15fa420f3.svg";
export { ForwardRef as ReactComponent };